import { Component, Element, h, Host } from "@stencil/core";

@Component({
    tag: "snt-blog-feature-articles",
    styleUrl: "blog-feature-articles-component.scss",
    shadow: false,
})
export class SntBlogFeaturedArticles {

    @Element() hostElement: HTMLElement;

    render() {
        return (
            <Host>
                <div class="spacings">
                    <slot/>
                </div>
            </Host>
        );
    }
}
